export const enum FlowVersion {
  SignIn = 'sign_in',
  SignUp = 'sign_up',
}
